var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"steps"},[_c('ul',_vm._l((_vm.tabs),function(tab,i){return _c('li',{key:i,class:[
                    i < _vm.step ? 'completed' : '',
                    i == _vm.step ? 'current' : '' ]},[_c('span',[_vm._v(_vm._s(i + 1))]),_vm._v(" "+_vm._s(tab.title)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }